export const formateTime = (
  startTime: any,
  endTime: any,
  normalTime: boolean,
) => {
  const nowTime = Date.now();
  let duration: any;
  if (endTime) {
    duration = new Date(Math.round(endTime / 1000000 - startTime / 1000000));
  } else {
    duration = new Date(Math.round(nowTime - startTime / 1000000));
  }
  // 计算总共有多少秒
  let totalSeconds = Math.floor(duration / 1000);
  // 计算有多少小时
  let hours: any = Math.floor(totalSeconds / 3600);
  // 剩余的秒数
  let secondsLeft = totalSeconds % 3600;
  // 计算分钟数
  let minutes: any = Math.floor(secondsLeft / 60);
  // 剩余的秒数
  let seconds: any = secondsLeft % 60;
  if (!normalTime) {
    return {
      time:
        hours > 0
          ? `${hours}h${minutes}m${seconds}s`
          : minutes > 0
            ? `${minutes}m${seconds}s`
            : `${seconds}s`,
      totalSeconds: totalSeconds,
    };
  } else {
    // 把时、分、秒都补全成两位数
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    // 组合时分秒
    return hours + ':' + minutes + ':' + seconds;
  }
};

export enum BootStatus {
  STARTING = 'STARTING',
  START_FAILED = 'START_FAILED',
  START_SUCCESS = 'START_SUCCESS',
  SHUT_DOWN_SUCCESS = 'SHUT_DOWN_SUCCESS',
  NO_STATUS = 'NO_STATUS',
}
